import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=4b4e0f2e&scoped=true&"
import script from "./HelpDetail.vue?vue&type=script&lang=js&"
export * from "./HelpDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpDetail.vue?vue&type=style&index=0&id=4b4e0f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e0f2e",
  null
  
)

export default component.exports